<template>
  <div>
    <b-row>
      <b-col
        cols="12"
        md="8"
      >
        <b-card no-body>
          <b-card-header class="d-flex align-items-center justify-content-between">
            <b-card-title>
              {{ dataItem.title }}
              <b-badge
                v-if="dataItem.archived"
                v-b-tooltip.hover
                :title="'Arşive alınma: ' + dataItem.archived"
                variant="light-warning"
                class="ml-50 align-middle"
              >
                <feather-icon icon="ArchiveIcon" />
                Arşivde
              </b-badge>
            </b-card-title>
            <b-card-sub-title>
              Hizmet Kodu: {{ dataItem.scode }}
            </b-card-sub-title>
            <b-button
              v-if="canArchiveManage && dataItem.id"
              size="sm"
              :variant="dataItem.archived ? 'outline-success' : 'outline-warning'"
              @click="toggleArchive"
            >
              <feather-icon :icon="dataItem.archived ? 'RotateCcwIcon' : 'ArchiveIcon'" />
              {{ dataItem.archived ? 'Arşivden Geri Yükle' : 'Arşivle' }}
            </b-button>
          </b-card-header>
          <b-card-body>
            <div class="mb-1 border-bottom pb-1">
              <div class="font-weight-bold font-medium-1">
                Hizmet Kategorisi
              </div>
              <div>{{ dataItem.category }}</div>
            </div>
            <div class="mb-1 border-bottom pb-1">
              <div class="font-weight-bold font-medium-1">
                Departman
              </div>
              <div>{{ dataItem.department }}</div>
            </div>
            <div class="mb-1 border-bottom pb-1">
              <div class="font-weight-bold font-medium-1">
                Ekip
              </div>
              <div>{{ dataItem.team }}</div>
            </div>
            <div
              v-if="dataItem.description"
              class="mb-1 border-bottom pb-1"
            >
              <div class="font-weight-bold font-medium-1">
                Açıklama
              </div>
              <div>
                <div v-html="dataItem.description" />
              </div>
            </div>
            <div
              v-if="dataItem.notes"
              class="mb-1"
            >
              <div class="font-weight-bold font-medium-1">
                Notlar
              </div>
              <div>
                {{ dataItem.notes }}
              </div>
            </div>
            <div
              v-if="dataItem.urls.length"
              class="mb-1"
            >
              <div class="font-weight-bold font-medium-1">
                İlgili Site Bağlantıları
              </div>
              <div
                v-for="(url,key) in dataItem.urls"
                :key="key"
                class="border-bottom mt-1 pb-1"
              >
                <b-link
                  class="font-weight-bold"
                  target="_blank"
                  :href="url.url"
                >
                  <div class="d-flex align-items-center">
                    <div
                      class="bg-secondary mr-1 text-white d-flex align-items-center justify-content-center rounded-circle"
                      style="width: 30px; height: 30px;"
                    >
                      <FeatherIcon icon="ExternalLinkIcon" />
                    </div>
                    <div>
                      {{ url.title }}
                      <div class="font-small-2 text-primary">
                        {{ url.url }}
                      </div>
                    </div>
                  </div>
                </b-link>
              </div>
            </div>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col
        cols="12"
        md="4"
      >
        <b-card
          no-body
          class="overflow-hidden"
        >
          <div class="d-flex align-items-start">
            <b-img
              :src="dataItem.image"
              fluid
            />
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BCardBody, BImg, BCardTitle, BCardHeader, BCardSubTitle, BLink, BBadge, BButton, VBTooltip,
} from 'bootstrap-vue'
import archiveActions from '@/mixins/archiveActions'

export default {
  name: 'ServicesServiceCard',
  components: {
    BCardSubTitle,
    BCardHeader,
    BCardTitle,
    BImg,
    BCardBody,
    BCard,
    BRow,
    BCol,
    BLink,
    BBadge,
    BButton,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  mixins: [archiveActions],
  computed: {
    canArchiveManage() {
      return this.$can('read', 'SERVICES_ARCHIVE_MANAGE')
    },
    dataItem() {
      return this.$store.getters['services/dataItem']
    },
  },
  created() {
    this.getDataItem()
  },
  methods: {
    toggleArchive() {
      this.changeArchive('services', this.dataItem.id, !this.dataItem.archived).then(res => {
        if (res && res.status) {
          this.getDataItem()
        }
      })
    },
    getDataItem() {
      this.$store.dispatch('services/getDataItem', this.$route.params.id)
    },
  },
}
</script>
